namespace GpScot.Downloads {
    export function init() {
        // Event Listener to override download link with new temporary link with object URL
        document.querySelectorAll<HTMLAnchorElement>('a[download]').forEach(downloadLink => {

            downloadLink.addEventListener('click', (event: MouseEvent) => {

                event.preventDefault();

                const target = event.currentTarget as HTMLAnchorElement;
                const url = target.getAttribute('href');
                const fileName = target.getAttribute('download');
                const options: RequestInit = {};

                if (url && fileName) {
                    fetch(url, options)
                        .then(res => res.blob())
                        .then(blob => {
                            downloadBlob(blob, fileName);
                        });
                }

                function downloadBlob(blob: Blob, name: string) {
                    const blobUrl = URL.createObjectURL(blob);
                    const link = document.createElement("a");

                    link.href = blobUrl;
                    link.download = name;

                    document.body.appendChild(link);

                    link.dispatchEvent(
                        new MouseEvent('click', {
                            bubbles: true,
                            cancelable: true
                        })
                    );

                    document.body.removeChild(link);
                }
            });
        });
    }
}
